import Box from 'components/shared/Box'
import styled from 'styled-components'
import { fadeInOnRender } from 'styles/animations'

export const CityBreakTicketsContainer = styled(Box)`
    width: 100%;
    ${fadeInOnRender}
`
